module.exports = {
  schema: {
    name: '多層膜資料',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        unique: true,
        name: '多層膜代碼',
      },
      name: {
        type: 'String',
        name: '多層膜名稱',
      },
      type: {
        type: 'String',
        name: '多層膜類別',
      },
    },
  },
  index: {
    primary: {
      key: {
        name: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 120 },
        { key: 'name', width: 190 },
        { key: 'type', width: 110 },
      ],
    },
    editor: {
      config: { titleMd: 2 },
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name' }],
            [{ key: 'type' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/lensCoatings.js